import { updateObject } from 'store/utility';
import * as types from '../actions/actionTypes';

const initialState = {
  patientInfo: {},
  recordingSample: null,
  comparerecordingSample:null,
  reviewDetail: null,
  isLoadingPatientData: false,
  errorGettingPatientData: '',
  errorGettingBaseRhythm: false,
  errorGettingAcuity: false,
  errorGettingQualityData: false,
  baseRhythm: [],
  acuity: [],
  quality: [],
  morphologyChanges:[],
  isSubmittingReview: false,
  isReviewSubmitted: 0,
  showToast: false,
  isLoadingCancelReview: false,
  reviewStatus: false,
  reviewErrorMessage: '',
  reportId: '',
  reviewFieldUpdated: false,
  comparerecordingsSample:null,
  secondaryvalues:null,
  isEcgScrolled:'',
  medianBeat:{},
  isBaseRecording:false,
  timeRemainingToEdit:[]
};

const getPatientData = (state, action) => {
  return updateObject(state, {
    patientInfo: action.payload.patientDetail,
    recordingSample: action.payload.recordingSample,
    reviewDetail: action.payload.reviewDetail,
    medianBeat:action.payload.medianBeatPlot,
    isBaseRecording:action.payload.isBaseRecording
  });
};

const setIsLoadingPatientData = (state, action) => {
  return updateObject(state, {
    isLoadingPatientData: action.payload,
  });
};

const setIsSubmittingReview = (state, action) => {
  return updateObject(state, {
    isSubmittingReview: action.payload,
  });
};

const errorInGettingPatientData = (state, action) => {
  return updateObject(state, {
    errorGettingPatientData: action.payload,
  });
};

const setIsErrorGettingBaseRhythmData = (state, action) => {
  return updateObject(state, {
    errorGettingBaseRhythm: action.payload,
  });
};

const setIsErrorGettingAcuityData = (state, action) => {
  return updateObject(state, {
    errorGettingAcuity: action.payload,
  });
};

const setIsErrorGettingQualityData = (state, action) => {
  return updateObject(state, {
    errorGettingQualityData: action.payload,
  });
};

const submitPatientReportId = (state, action) => {
  return updateObject(state, {
    reportId: action.payload,
  });
};

const emptyPatientData = (state, action) => {
  return updateObject(state, {
    patientInfo: {},
    recordingSample: null,
    reviewDetail: null,
  });
};

const getBaseRythmData = (state, action) => {
  return updateObject(state, {
    baseRhythm: action.payload,
  });
};

const getAcuity = (state, action) => {
  return updateObject(state, {
    acuity: action.payload,
  });
};

const getqualityData = (state, action) => {
  return updateObject(state, {
    quality: action.payload,
  });
};


const getLeadMorphologyChanges = (state, action) => {
  return updateObject(state, {
    morphologyChanges: action.payload,
  });
};


const showToastHandler = (state, action) => {
  return updateObject(state, {
    showToast: action.payload,
  });
};

const submitReview = (state, action) => {
  return updateObject(state, {
    isReviewSubmitted: action.payload,
  });
};

const isLoadingCancelReview = (state, action) => {
  return updateObject(state, {
    isLoadingCancelReview: action.payload,
  });
};

const reviewStatus = (state, action) => {
  return updateObject(state, {
    reviewStatus: action.payload,
  });
};

const setDefaultSubmitStatus = (state, action) => {
  return updateObject(state, {
    isReviewSubmitted: 0,
  });
};

const setReviewErrorMessage = (state, action) => {
  return updateObject(state, {
    reviewErrorMessage: action.payload,
  });
};
const reviewFieldUpdated = (state, action) => {
  return updateObject(state, {
    reviewFieldUpdated: action.payload,
  });
};

const ecgcompareUpdated = (state, action) => {
  return updateObject(state, {
    comparerecordingsSample: action.payload,
  });
};

const getsecondarystoredvalues = (state, action) => {
  return updateObject(state, {
    secondaryvalues: action.payload,
  });
};

const emptysecondaryvalues = (state, action) => {
  return updateObject(state, {
    secondaryvalues: null,
  });
};

const isEcgScrolled = (state, action) => {
  return updateObject(state, {
    isEcgScrolled: action.payload,
  });
};


const timeRemainingtoEdit = (state, action) => {
  return updateObject(state, {
    timeRemainingToEdit: action.payload,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_PATIENTDATA_SUCCESS:
      return getPatientData(state, action);
    case types.GETBASERHYTHM:
      return getBaseRythmData(state, action);
    case types.GETACUITY:
      return getAcuity(state, action);
    case types.GETQUALITY:
      return getqualityData(state, action);
    case types.IS_SUBMITTING_REPORT:
      return setIsSubmittingReview(state, action);
    case types.SUBMITREVIEW:
      return submitReview(state, action);
    case types.SETDEFAULTSUBMITSTATUS:
      return setDefaultSubmitStatus(state, action);
    case types.IS_LOADING_CANCEL_REVIEW:
      return isLoadingCancelReview(state, action);
    case types.REVIEWSTATUS:
      return reviewStatus(state, action);
    case types.EMPTYPATIENTDATA:
      return emptyPatientData(state, action);
    case types.SUMBITPATIENTREPORTID:
      return submitPatientReportId(state, action);
    case types.SHOWTOAST:
      return showToastHandler(state, action);
    case types.IS_LOADING_PATIENT_DATA:
      return setIsLoadingPatientData(state, action);
    case types.IS_ERROR_GETTING_PATIENT_DATA:
      return errorInGettingPatientData(state, action);
    case types.IS_ERROR_GETTING_RHYTHM_DATA:
      return setIsErrorGettingBaseRhythmData(state, action);
    case types.IS_ERROR_GETTING_ACUITY_DATA:
      return setIsErrorGettingAcuityData(state, action);
    case types.REVIEW_ERROR_MESSAGE:
      return setReviewErrorMessage(state, action);
    case types.IS_ERROR_GETTING_QUALITY_DATA:
      return setIsErrorGettingQualityData(state, action);
    case types.IS_REVIEW_FIELD_UPDATED:
      return reviewFieldUpdated(state, action);
    case types.GET_PATIENTDATA_SUCCESS_COMPARE:
        return ecgcompareUpdated(state, action);
    case types.SECONDARY_DROP_VALUES_STORE:
      return getsecondarystoredvalues(state,action)
    case types.EMPTY_SECONDARY_VALUES:
       return emptysecondaryvalues(state,action)
    case types.IS_ECG_SCROLLED:
        return isEcgScrolled(state,action)
    case types.LEAD_MORPHOLOGY_CHANGES:
      return getLeadMorphologyChanges(state,action)
    case types.TIME_REMAINING_TO_EDIT:
      return timeRemainingtoEdit(state, action)
    default:
      return state;
  }
};

export default reducer;
